import { JsonProperty, JsonObject } from 'json2typescript';
import {
  ExtendedTestInterface,
  SpeedometerInterace,
} from '../interfaces/extendedTest.interface';

@JsonObject('SpeedometerModel')
export class SpeedometerModel implements SpeedometerInterace {
  @JsonProperty('Max', Number, true)
  max: number = undefined;

  @JsonProperty('Min', Number, true)
  min: number = undefined;

  @JsonProperty('Score', Number, true)
  score: number = undefined;

  @JsonProperty('Text', String, true)
  text: string = undefined;
}

@JsonObject('ExtendedTestModel')
export class ExtendedTestModel implements ExtendedTestInterface {
  @JsonProperty('RiskAppetite', SpeedometerModel, true)
  riskAppetite: SpeedometerInterace = undefined;

  @JsonProperty('LiquidityNeeds', SpeedometerModel, true)
  liquidityNeeds: SpeedometerInterace = undefined;

  @JsonProperty('InvestmentObjective', SpeedometerModel, true)
  investmentObjective: SpeedometerInterace = undefined;

  @JsonProperty('ProfileDescription', String, true)
  profileDescription: string = undefined;

  @JsonProperty('ProfileId', Number, true)
  profileId: number = undefined;

  @JsonProperty('ProfileName', String, true)
  profileName: string = undefined;

  @JsonProperty('XScore', Number, true)
  xScore: number = undefined;

  @JsonProperty('YScore', Number, true)
  yScore: number = undefined;
}
